// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Comoros */
const KM = /^(?:[34]\d{6})$/;

export default KM;
